module.exports = __webpack_public_path__ + "static/media/mode-522.8994f1f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-522.svg
// module id = 1047
// module chunks = 2